export const OrderStatus = {
  NEW: "new",
  BOOKED: "booked",
  DELIVERED: "delivered",
  INTRANSIT: "in-transit",
  CANCELLED: "cancelled",
  QUOTED: "quoted",
  SAVED: "saved",
  INVOICED: "invoiced",
  INVOICEPAID: "invoicepaid",
};
